<template>
  <ion-page>
    <ion-progress-bar
      :value="Math.random(0, 1)"
      v-show="$store.state.hide"
    ></ion-progress-bar>
    <ion-content :scroll-events="true">
      <div class="chatroom-wrapper" v-if="$store.state.authuser">
        <div
          class="left-part"
          style="z-index: 990"
          v-if="$store.state.authuser"
        >
          <div class="top-header" v-if="$store.state.authuser">
            <div
              class="profile-image"
              v-if="
                $store.state.authuser &&
                $store.state.authuser.image !== $store.state.avatar
              "
              @click="$router.replace(`/profile/${$store.state.authuser.id}`)"
            >
              <img
                :src="`${this.$store.state.endpoints.appUrl}${$store.state.authuser.image}`"
                alt=""
              />
            </div>
            <div v-else>
              <avatar
                :username="$store.state.authuser.username"
                style="width: 40px; height: 40px"
              ></avatar>
            </div>
            <div class="action-effectors">
              <div class="clubs" @click="$router.replace('/home')">
                <svg-icon
                  name="home"
                  style="width: 20px; height: 20px"
                ></svg-icon>
              </div>
              <div class="new-message fire-modal">
                <svg-icon
                  name="comment-plus"
                  style="width: 20px; height: 20px"
                ></svg-icon>
              </div>

              <div class="clubs" @click="$router.replace('/clubs')">
                <svg-icon
                  name="club"
                  style="width: 20px; height: 20px"
                ></svg-icon>
              </div>
            </div>
          </div>
          <div class="adjacent-search-bar">
            <span class="cancel"
              ><i><svg-icon name="arrow-left" /></i
            ></span>
            <span class="search"
              ><i><svg-icon name="searching"></svg-icon></i
            ></span>
            <input
              type="search"
              name=""
              class="search-control"
              placeholder="Search chat"
              v-model="search"
            />
          </div>
          <div class="chat-options-wrapper">
            <div
              class="specific-chat"
              v-for="(chat, index) in sortedContacts"
              :key="index"
              @click="selectedContact(chat)"
            >
              <div
                class="chat-profile-image"
                v-if="
                  $store.state.authuser &&
                  chat.sender.id == $store.state.authuser.id
                    ? chat.receiver &&
                      chat.receiver.image !== $store.state.avatar
                    : chat.sender && chat.sender.image !== $store.state.avatar
                "
              >
                <img
                  v-if="chat.sender"
                  :src="
                    $store.state.authuser &&
                    chat.sender.id == $store.state.authuser.id
                      ? `${this.$store.state.endpoints.appUrl}${chat.receiver.image}`
                      : `${this.$store.state.endpoints.appUrl}${chat.sender.image}`
                  "
                  alt=""
                />
              </div>
              <div v-else>
                <avatar
                  :username="
                    $store.state.authuser &&
                    chat.sender.id == $store.state.authuser.id
                      ? chat.receiver.username
                      : chat.sender.username
                  "
                  style="width: 40px; height: 40px"
                ></avatar>
              </div>
              <div class="chat-content">
                <div class="chat-name" v-if="$store.state.authuser">
                  <h4 v-if="chat.sender.id == $store.state.authuser.id">
                    {{ chat.receiver.username }}
                  </h4>
                  <h4 v-else>{{ chat.sender.username }}</h4>
                  <p class="time-stamp">{{ getHumanDate(chat.created_at) }}</p>
                </div>
                <div class="chat-body">
                  <p class="text" v-if="chat.has_image">📷 Image</p>
                  <p class="text" v-else-if="chat.has_video">📹 Video</p>
                  <p
                    class="text flex"
                    v-else-if="chat.deletes && chat.deletes.length"
                  >
                    <slot name="deleted-icon">
                      <svg-icon
                        style="fill: red"
                        name="deleted"
                        class="vac-icon-deleted"
                      />
                    </slot>
                    <span
                      v-if="
                        chat.sender &&
                        $store.state.authuser &&
                        chat.sender.id == $store.state.authuser.id
                      "
                      >You deleted this message</span
                    ><span v-else>This message was deleted</span>
                  </p>
                  <p class="text" v-else>{{ chat.text }}</p>
                  <span
                    class="unread"
                    v-if="
                      chat &&
                      $store.state.authuser &&
                      chat.sender &&
                      chat.sender.id != $store.state.authuser.id &&
                      chat.unread
                    "
                    >{{ chat.unread }}</span
                  >
                  <span v-else></span>
                  <span
                    class="unread1"
                    v-if="
                      $store.state.authuser &&
                      chat.sender &&
                      chat.sender.id == $store.state.authuser.id
                    "
                  >
                    <div
                      class="profile-image"
                      style="
                        display: flex;
                        justify-content: flex-end;
                        width: 15px;
                        height: 15px;
                        float: right;
                        margin-top: 3px;
                      "
                      v-if="
                        chat.read == 1 &&
                        chat.sender &&
                        chat.sender.id == $store.state.authuser.id
                      "
                    >
                      <img
                        :src="
                          $store.state.authuser &&
                          chat.sender &&
                          chat.sender.id == $store.state.authuser.id
                            ? `${this.$store.state.endpoints.appUrl}${chat.receiver.image}`
                            : `${this.$store.state.endpoints.appUrl}${chat.sender.image}`
                        "
                      />
                    </div>
                    <div
                      class="profile-image"
                      style="
                        display: flex;
                        justify-content: flex-end;
                        width: 15px;
                        height: 15px;
                        float: right;
                        margin-top: 3px;
                      "
                      v-else-if="
                        chat.read == 0 &&
                        chat.sender &&
                        chat.sender.id == $store.state.authuser.id
                      "
                    >
                      ✔️
                    </div>
                  </span>
                  <span v-else></span>
                </div>
              </div>
            </div>
            <infinite-loading
              spinner="bubble"
              ref="list"
              @infinite="infiniteHandler"
              :identifier="identifier"
            >
              <div class="text-red" slot="no-more">No more Users</div>
              <div class="text-red" slot="no-results">No more Users</div>
            </infinite-loading>
          </div>
        </div>
        <div class="right-part">
          <div class="main-body">
            <div class="right-top-header">
              <span class="exchange">
                <i><svg-icon name="arrow-left" /></i>
              </span>
              <div class="top-header-inner">
                <div class="responder-profile">
                  <div class="profile-image" v-if="contact">
                    <div
                      v-if="
                        $store.state.authuser &&
                        contact.sender.id == $store.state.authuser.id
                          ? contact.receiver &&
                            this.$store.state.endpoints.appUrl +
                              contact.receiver.image !==
                              $store.state.avatar
                          : contact.sender &&
                            this.$store.state.endpoints.appUrl +
                              contact.sender.image !==
                              $store.state.avatar
                      "
                    >
                      <img
                        v-if="contact.sender"
                        :src="
                          $store.state.authuser &&
                          contact.sender.id == $store.state.authuser.id
                            ? `${this.$store.state.endpoints.appUrl}${contact.receiver.image}`
                            : `${this.$store.state.endpoints.appUrl}${contact.sender.image}`
                        "
                        alt=""
                      />
                    </div>
                    <div v-else>
                      <avatar
                        :username="
                          $store.state.authuser &&
                          contact.sender.id == $store.state.authuser.id
                            ? contact.receiver.username
                            : contact.sender.username
                        "
                        style="width: 40px; height: 40px"
                      ></avatar>
                    </div>
                  </div>
                  <div class="responder-name">
                    <h4 v-if="contact">
                      {{
                        $store.state.authuser &&
                        contact.sender.id == $store.state.authuser.id
                          ? contact.receiver.username
                          : contact.sender.username
                      }}
                    </h4>
                    <p v-if="contact">
                      {{
                        $store.state.authuser &&
                        contact.sender.id == $store.state.authuser.id
                          ? `${
                              typing === false && contact.receiver.online
                                ? "Online"
                                : `Last seen  ${getHumanDateLastSeen(
                                    contact.receiver.last_sen == null
                                      ? contact.receiver.last_seen
                                      : contact.receiver.last_sen
                                  )}`
                            }`
                          : `${
                              typing === false && contact.sender.online
                                ? "Online"
                                : `Last seen  ${getHumanDateLastSeen(
                                    contact.sender.last_sen == null
                                      ? contact.sender.last_seen
                                      : contact.sender.last_sen
                                  )}`
                            }`
                      }}
                    </p>
                  </div>
                </div>
                <div class="responder-actions">
                  <span class="search-chat"
                    ><i><svg-icon name="searching" /></i
                  ></span>
                  <span class="options-btn"
                    ><i><svg-icon name="ellipsis-v" /></i
                  ></span>
                  <span class="options-btn1"
                    ><i><svg-icon name="setting" @click="action = true" /></i
                  ></span>
                  <!-- mobile popup box for additional options -->
                  <div class="mobile-options">
                    <span class="search-chat1" style="display: flex">
                      <i><svg-icon name="searching" /></i>
                      Search
                    </span>
                    <span style="display: flex">
                      <i><svg-icon name="block" /></i>
                      Block
                    </span>
                    <span style="display: flex">
                      <i><svg-icon name="deleted" /></i>
                      Delete chat
                    </span>
                  </div>

                  <!-- mobile popup box for additional options -->
                  <div class="mobile-options1" v-if="action === true">
                    <span class="exchang" @click="action = false">
                      <i><svg-icon name="arrow-left" /></i>
                    </span>
                    <div class="profile-image1" style="margin: auto">
                      <img
                        :src="`${this.$store.state.endpoints.appUrl}${
                          $store.state.authuser &&
                          contact.sender.id == $store.state.authuser.id
                            ? contact.receiver.image
                            : contact.sender.image
                        }`"
                        alt=""
                        v-if="contact"
                        @click="
                          $router.replace(
                            `/profile/${
                              $store.state.authuser &&
                              contact.sender.id == $store.state.authuser.id
                                ? contact.receiver.id
                                : contact.sender.id
                            }`
                          )
                        "
                      />
                    </div>
                    <div
                      style="
                        margin-right: auto;
                        margin-left: auto;
                        display: flex;
                        justify-content: center;
                        margin-top: 5px;
                      "
                    >
                      <h4 style="font-weight: bold">
                        {{
                          $store.state.authuser &&
                          contact.sender.id == $store.state.authuser.id
                            ? contact.receiver.username
                            : contact.sender.username
                        }}
                      </h4>
                    </div>
                    <!--   <p v-if="!$store.state.contact.isOnline" style="margin-right: auto;margin-left: auto;display:flex;justify-content:center;margin-top:5px;">Last seen {{$store.state.contact.created}}</p><p v-else-if="$store.state.contact.isOnline" style="margin-right: auto;margin-left: auto;display:flex;justify-content:center;margin-top:5px;color:green;">is online</p> -->
                    <p
                      v-if="contact"
                      style="
                        margin-right: auto;
                        margin-left: auto;
                        display: flex;
                        justify-content: center;
                        margin-top: 5px;
                      "
                    >
                      {{
                        $store.state.authuser &&
                        contact.sender.id == $store.state.authuser.id
                          ? `${
                              typing === false && contact.receiver.online
                                ? "Online"
                                : `Last seen  ${getHumanDateLastSeen(
                                    contact.receiver.last_sen == null
                                      ? contact.receiver.last_seen
                                      : contact.receiver.last_sen
                                  )}`
                            }`
                          : `${
                              typing === false && contact.sender.online
                                ? "Online"
                                : `Last seen  ${getHumanDateLastSeen(
                                    contact.sender.last_sen == null
                                      ? contact.sender.last_seen
                                      : contact.sender.last_sen
                                  )}`
                            }`
                      }}
                    </p>
                    <span class="search-chat1" style="display: flex">
                      <i><svg-icon name="searching" /></i>
                      Search
                    </span>
                    <hr />
                    <span style="display: flex">
                      <i><svg-icon name="block" /></i>
                      Block
                    </span>
                    <hr />
                    <span style="display: flex">
                      <i><svg-icon name="deleted" /></i>
                      Delete chat
                    </span>
                    <hr />
                  </div>
                </div>
              </div>
            </div>
            <div class="chat-section">
              <div class="messages-themselfu" ref="feed">
                <infinite-loading
                  spinner="default"
                  ref="infiniteLoadingConverse"
                  direction="top"
                  :distance="40"
                  @infinite="infiniteHandlerConversation"
                >
                  <div class="text-red" slot="no-more"></div>
                  <div class="text-red" slot="no-results"></div>
                </infinite-loading>
                <div class="messages-title" v-if="messages.length">
                  <p>
                    Chat started on
                    {{ getHumanDateStarted(messages[0].created_at) }}
                  </p>
                </div>
                <div v-for="(message, index) in messages" :key="index">
                  <div
                    class="vac-card-info vac-card-date"
                    v-if="
                      index > 0 &&
                      getHumanDateFormatTime(message.created_at) !==
                        getHumanDateFormatTime(messages[index - 1].created_at)
                    "
                  >
                    <p>{{ getHumanDateStarted(message.created_at) }}</p>
                  </div>

                  <div
                    class="message"
                    :class="`${
                      $store.state.authuser &&
                      message.sender.id == $store.state.authuser.id
                        ? ' inquire'
                        : ' reply'
                    }`"
                  >
                    <div
                      class="message-details"
                      v-if="message.deletes && message.deletes.length"
                    >
                      <p class="vac-message-deleted flex">
                        <slot name="deleted-icon">
                          <svg-icon
                            style="fill: red"
                            name="deleted"
                            class="vac-icon-deleted"
                          />
                        </slot>
                        <span
                          v-if="
                            message.sender &&
                            $store.state.authuser &&
                            message.sender.id == $store.state.authuser.id
                          "
                          >You deleted this message</span
                        ><span v-else>This message was deleted</span>
                      </p>
                    </div>
                    <div
                      class="message-details"
                      v-else-if="message.replies && message.replies.length"
                    >
                      <message-actions
                        :text="message.replies[0].fields.text"
                        :image="
                          message.replies[0].fields.type === 'image'
                            ? message.replies[0].fields.messageFile
                            : ''
                        "
                        :video="
                          message.replies[0].fields.type === 'video'
                            ? message.replies[0].fields.messageFile
                            : ''
                        "
                        :style="
                          message.sender.id == contact.id
                            ? 'background:white;'
                            : 'background:#50b5ff'
                        "
                        :class="
                          message.sender.id == contact.id
                            ? 'text-dark'
                            : 'text-white'
                        "
                        v-if="message.replies[0].fields.text"
                      />
                      <p
                        style="white-space: pre-line"
                        v-if="message.text !== 'null'"
                      >
                        {{ message.text }}
                      </p>
                    </div>
                    <div class="message-details" v-else-if="message.has_video">
                      <div
                        style="
                          position: absolute;
                          left: 0;
                          right: 0;
                          z-index: 999;
                        "
                      >
                        <action-component :message="message" :index="index" />
                      </div>
                      <div class="post-photo">
                        <div id="photo-grid">
                          <photo-grid
                            :box-height="'300px'"
                            :box-width="'300px'"
                            :excess-text="'+ {{count}}'"
                            @clickExcess="
                              triggerClick(
                                message.videos[message.videos.length - 1].fields
                                  .filename
                              )
                            "
                          >
                            <video
                              v-for="(video, index) in message.videos"
                              :key="index"
                              style="width: 100%; height: 100%"
                              controls
                            >
                              <source
                                :src="
                                  $store.state.endpoints.appUrlVideo +
                                  video.fields.filename
                                "
                                type="video/mp4"
                              />
                              <source
                                :src="
                                  $store.state.endpoints.appUrlVideo +
                                  video.fields.filename
                                "
                                type="video/ogg`"
                              />
                              <source
                                :src="
                                  $store.state.endpoints.appUrlVideo +
                                  video.fields.filename
                                "
                                type="video/webm`"
                              />
                            </video>
                          </photo-grid>
                        </div>
                      </div>

                      <p style="white-space: pre-line; margin-right: 10px">
                        <!-- {{ message.text }} -->
                      </p>
                      <div class="time-of-post">
                        <span class="time">{{
                          getHumanDate(message.created_at)
                        }}</span>
                      </div>
                      <div
                        class=""
                        style="font-weight: bold; margin-left: 0px"
                        v-if="
                          (message.sender &&
                            $store.state.authuser &&
                            message.sender.id != $store.state.authuser.id) ||
                          (message.reacts && message.reacts.length)
                        "
                      >
                        <react-component
                          :message="message"
                          :index="index"
                          :user_id="$store.state.authuser.id"
                        ></react-component>
                      </div>
                    </div>
                    <div class="message-details" v-else-if="message.has_image">
                      <div
                        style="
                          position: absolute;
                          left: 0;
                          right: 0;
                          z-index: 999;
                        "
                      >
                        <action-component :message="message" :index="index" />
                      </div>
                      <div class="post-photo">
                        <div id="photo-grid">
                          <photo-grid
                            :box-height="'300px'"
                            :box-width="'300px'"
                            :excess-text="'+ {{count}}'"
                            @clickExcess="
                              triggerClick(
                                message.images[message.images.length - 1].fields
                                  .filename
                              )
                            "
                          >
                            <img
                              v-for="(image, index) in message.images"
                              :src="
                                image.fields.filename
                                  ? `${this.$store.state.endpoints.appUrl}${image.fields.filename}`
                                  : image
                              "
                              :key="index"
                              style="border-radius: 25px; z-index: 88"
                              @click="
                                thimage(message.images), openGallery(index)
                              "
                            />
                          </photo-grid>
                        </div>
                      </div>

                      <p style="white-space: pre-line; margin-right: 10px">
                        {{ message.text }}
                      </p>
                      <div class="time-of-post">
                        <span class="time">{{
                          getHumanDate(message.created_at)
                        }}</span>
                      </div>
                      <div
                        class=""
                        style="font-weight: bold; margin-left: 0px"
                        v-if="
                          (message.sender &&
                            $store.state.authuser &&
                            message.sender.id != $store.state.authuser.id) ||
                          (message.reacts && message.reacts.length)
                        "
                      >
                        <react-component
                          :message="message"
                          :index="index"
                          :user_id="$store.state.authuser.id"
                        ></react-component>
                      </div>
                    </div>
                    <div class="message-details" v-else>
                      <div style="position: absolute; left: 0; right: 0">
                        <action-component :message="message" :index="index" />
                      </div>
                      <p style="white-space: pre-line; margin-right: 10px">
                        {{ message.text }}
                      </p>
                      <div class="time-of-post">
                        <span class="time">{{
                          getHumanDate(message.created_at)
                        }}</span>
                      </div>
                      <!-- <div class="actions1" style="font-size: 1.5rem">❤️</div> -->
                      <div
                        class=""
                        style="font-weight: bold; margin-left: 0px"
                        v-if="
                          (message.sender &&
                            $store.state.authuser &&
                            message.sender.id != $store.state.authuser.id) ||
                          (message.reacts && message.reacts.length)
                        "
                      >
                        <react-component
                          :message="message"
                          :index="index"
                          :user_id="$store.state.authuser.id"
                        ></react-component>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="typing"
                  style="background-color: #e0e0e0"
                  v-show="typing"
                >
                  <span class="circle scaling"></span>
                  <span class="circle bouncing"></span>
                  <span class="circle scaling"></span>
                </div>
                <!-- <span v-if="messages && messages[messages.length - 1]">
                  {{ messages[messages.length - 1].read }}</span
                > -->

                <div
                  class="profile-image"
                  style="
                    display: flex;
                    justify-content: flex-end;
                    width: 25px;
                    height: 25px;
                    float: right;
                    margin-top: 20px;
                    margin-bottom: 10px;
                  "
                  v-if="
                    messages &&
                    messages[messages.length - 1] &&
                    messages[messages.length - 1].read == 1 &&
                    messages[messages.length - 1].sender.id ==
                      $store.state.authuser.id
                  "
                >
                  <img
                    :src="`${this.$store.state.endpoints.appUrl}${
                      $store.state.authuser &&
                      contact &&
                      contact.sender.id == $store.state.authuser.id
                        ? contact
                          ? contact.receiver.image
                          : null
                        : contact
                        ? contact.sender.image
                        : null
                    }`"
                  />
                </div>
              </div>
              <div class="popping-box1 card vac-message-highlight">
                <div class="popping-inner1">
                  <span class="close-emojis1" @click="remve"
                    ><i><svg-icon name="multiply" /></i
                  ></span>
                </div>
                <div class="d-flex">
                  <span
                    v-if="
                      messageType &&
                      messageType.image &&
                      messageType.image.length
                    "
                    ><img
                      :src="`${this.$store.state.endpoints.appUrl}${messageType.image[0].fields.filename}`"
                      style="width: 50px; height: 50px"
                      alt="" /></span
                  ><span
                    v-else-if="
                      messageType &&
                      messageType.video &&
                      messageType.video.length
                    "
                  >
                    <video style="width: 100px; height: 50px" controls>
                      <source
                        :src="`https://hyreads.com${messageType.video[0].filename}`"
                        type="video/mp4"
                      />
                    </video>
                  </span>
                  <span>{{ replyMessage }}</span>
                </div>
              </div>
              <input
                ref="files"
                type="file"
                id="read-filee"
                multiple
                hidden
                @change="onFileChange($event.target.files)"
              />
              <div class="preview-box">
                <div class="preview-box-inner">
                  <span class="close-preview" @click="closepreview"
                    ><i><svg-icon name="multiply" /></i
                  ></span>
                  <div class="preview-file">
                    <div v-if="isImage" class="vac-media-container">
                      <div class="vac-media-file">
                        <span
                          v-for="(image, index) in imageFile.slice(-1)"
                          :key="index"
                        >
                          <div class="vac-svg-button vac-icon-media"></div>
                          <img
                            :src="currentIndexImage ? currentIndexImage : image"
                          />
                        </span>
                      </div>
                    </div>
                    <div v-if="isVideo" class="vac-media-container">
                      <div class="vac-media-file">
                        <span v-for="(video, index) in videoFile" :key="index">
                          <video width="100%" height="100%" controls>
                            <source :src="video" type="video/mp4" />
                            <source :src="video" type="video/ogg" />
                            <source :src="video" type="video/webm" />
                          </video>
                        </span>
                      </div>
                    </div>
                    <div
                      class="preview-input-box"
                      v-if="imageFile.length || videoFile.length"
                    >
                      <textarea
                        name=""
                        id=""
                        cols="30"
                        rows="10"
                        class="insert-control1"
                        v-model="message_file"
                        placeholder="Type a message"
                      ></textarea>
                    </div>
                    <hr v-if="imageFile.length || videoFile.length" />
                    <div style="display: flex; justify-content: center">
                      <div
                        class="image-list-container display-flex flex-wrap"
                        v-if="imageFile.length || videoFile.length"
                      >
                        <div
                          v-if="isImage"
                          class="image-list-item position-relative cursor-pointer"
                          v-for="(image, index) in imageFile"
                          :key="index"
                          @click="changeHighlight(index, image)"
                          :class="
                            ind === index || index === imageFile.length
                              ? 'image-highlight'
                              : ''
                          "
                        >
                          <div class="centered">
                            <img class="show-img img-responsive" :src="image" />
                          </div>
                        </div>
                        <div
                          v-if="isVideo"
                          class="image-list-item position-relative cursor-pointer"
                          v-for="(video, index) in videoFile"
                          :key="index"
                        >
                          <div class="centered">
                            <video width="100%" height="100%">
                              <source :src="video" type="video/mp4" />
                              <source :src="video" type="video/ogg" />
                              <source :src="video" type="video/webm" />
                            </video>
                          </div>
                        </div>
                        <div
                          class="image-list-item position-relative cursor-pointer display-flex justify-content-center align-items-center"
                          style="cursor: pointer; z-index: 1999"
                        >
                          <span id="open-uploadid1" @click="alrt()"
                            ><svg-icon name="add-image"
                          /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="send-btn"
                      v-if="imageFile.length || videoFile.length"
                      @click="sendFile"
                    >
                      <span class="send-attachment"
                        ><i><svg-icon name="message" style="fill: white" /></i
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="replybox"></div>
              <div class="chat-input">
                <div class="chat-actions">
                  <span class="open-emojis" @click="sendMessageThumb">👍</span>
                  <!-- <span class="open-emojis" @click="sendMessageLove">❤️</span> -->
                  <emoji-picker></emoji-picker>
                  <span
                    class="open-upload"
                    id="open-uploadid"
                    style="margin-right: 2px"
                  >
                    <i><svg-icon name="paper-clip" /> </i>
                  </span>
                </div>
                <div class="chat-insert">
                  <textarea
                    @keydown="type($store.state.authuser.id)"
                    @keydown.esc="escapeTextarea"
                    @keydown.enter.exact.prevent=""
                    @input="onChangeInput"
                    v-model="message"
                    name=""
                    id=""
                    ref="roomTextarea3"
                    cols="30"
                    rows="10"
                    class="insert-control"
                    placeholder="Type a message"
                    style="
                      height: 30px;
                      overflow: hidden;
                      outline: 0;
                      resize: none;
                      border-radius: 20px;
                      padding: 6px 8px;
                      box-sizing: content-box;
                    "
                  ></textarea>
                </div>
                <div class="send-actions" style="display: flex">
                  <span class="microphone" style="margin-right: 13px">
                    <svg-icon name="microphone" />
                  </span>
                  <span class="send" @click="newMessage">
                    <svg-icon name="message"
                  /></span>
                </div>
              </div>
            </div>
            <div class="default-face">
              <div class="default-face-content">
                <div class="image-default">
                  <img src="assets/images/chatroom.png" alt="" />
                </div>
                <h2>Welcome to Creeb Chatroom</h2>
                <h4>You don't have any message selected.</h4>
                <p>Kindly click on the existing chats or start a new one.</p>
                <button class="fire-modal">New Message</button>
              </div>
            </div>
          </div>
          <!-- new message modal -->
          <div class="new-message-modal">
            <div class="message-modal-content">
              <div class="title">
                <h3>People you may know</h3>
              </div>
              <!-- <div class="modal-search-contact" style="display: flex">
                <span
                  ><i><svg-icon name="searching" /></i
                ></span>
                <input
                  type="search"
                  name=""
                  class="search-control"
                  placeholder="Search for friends"
                />
              </div> -->
              <!-- <span v-if="checked.length">{{ checked[0].id }}</span> -->
              <hr />
              <div
                class="people-accounts"
                style="max-height: 350px; overflow: scroll"
              >
                <div
                  class="person-account"
                  v-for="(suggest, index) in $store.state.friendSuggestions
                    .length
                    ? $store.state.friendSuggestions
                    : []"
                  :key="index"
                >
                  <div
                    class="person-profile"
                    v-if="!$store.state.friendSent.includes(suggest.id)"
                  >
                    <div
                      class="profile-image"
                      v-if="suggest.image !== $store.state.avatar"
                    >
                      <img
                        :src="`${this.$store.state.endpoints.appUrl}${suggest.image}`"
                        alt=""
                        style="height: 2rem; width: 2rem"
                      />
                    </div>
                    <div v-else>
                      <avatar
                        :username="suggest.name"
                        style="height: 2.6rem; width: 2.6rem"
                      ></avatar>
                    </div>
                    <div class="profile-name">
                      <h3>{{ suggest.username }}</h3>
                      <p>@{{ suggest.username }}</p>
                    </div>

                    <div
                      class="profile-name people-suggestions"
                      v-if="suggest.mutual"
                    >
                      <span
                        v-for="(person, index) in suggest.mutual.friends"
                        :key="index"
                      >
                        <img
                          :src="`${this.$store.state.endpoints.appUrl}${person.user.image}`"
                          alt=""
                          v-if="person.user.image !== $store.state.avatar"
                        />
                        <avatar
                          :username="person.user.name"
                          style="width: 1.4rem; height: 1.4rem"
                          v-else
                        ></avatar>
                      </span>
                    </div>
                  </div>

                  <div
                    class="selection"
                    v-if="!$store.state.friendSent.includes(suggest.id)"
                  >
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      :value="
                        userIdObj(suggest.id, suggest.username, suggest.image)
                      "
                      v-model="checked"
                    />
                  </div>
                </div>
              </div>
              <div class="btns-events">
                <button class="btn btn-cancel">Cancel</button>
                <button class="btn btn-submit" @click.prevent="att()">
                  Link
                </button>
              </div>
            </div>
          </div>

          <!-- search-messages-box -->
          <div class="search-messages">
            <div class="search-messages-top-bar top-header">
              <span class="close-search"
                ><i><svg-icon name="multiply" /></i
              ></span>
              <h4>Search through this chat</h4>
            </div>
            <div class="adjacent-search-bar">
              <span class="search"
                ><i><svg-icon name="searching" /></i
              ></span>
              <input
                type="search"
                name=""
                class="search-control"
                placeholder="Search chat"
              />
            </div>
            <p v-if="contact">
              Search your chat with
              {{
                $store.state.authuser &&
                contact.sender.id == $store.state.authuser.id
                  ? contact.receiver.username
                  : contact.sender.username
              }}
            </p>
            <p></p>
          </div>

          <!-- end of search messages-box -->
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonApp, IonContent, IonPage } from "@ionic/vue";
import {
  messagesUrl,
  createMessagesUrl,
  conversation,
} from "../../../constants/endpoints";
import MessageActions from "../../MessageActions";
// import { events } from "../../events";

import vClickOutside from "click-outside-vue3";
import Avatar from "../../Avatar";
import EmojiPicker from "../../EmojiPicker";
import ReactComponent from "../../Reactions";
import ReactThread from "../../ReactionThread";
import ActionComponent from "../../actionComponent";
import SvgIcon from "../../SvgIcon.vue";
const io = require("socket.io-client");
import InfiniteLoading from "vue-infinite-loading";
import { chatPermissions } from "../../../constants/chat";
import PhotoGrid from "../../PhotoGridComponent";
import moment from "moment";
import { events } from "../../../events";
const { detectMobile, iOSDevice } = require("../../../utils/mobileDetection");
const { isImageFile, isVideoFile } = require("../../../utils/mediaFile");
export default {
  components: {
    IonApp,
    IonContent,
    IonPage,
    Avatar,
    SvgIcon,
    InfiniteLoading,
    PhotoGrid,
    EmojiPicker,
    ActionComponent,
    MessageActions,
    ReactComponent,
    ReactThread,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      search: null,
      imag: null,
      vide: null,
      action: false,
      dataa1: { soundurl: "assets/sound/reaction.mp3" },
      dataa: { soundurl: "assets/sound/messenger.mp3" },
      socket: io("https://hyreads.com:3000/"),
      page: 2,
      pageConverse: 1,
      lastPage: 0,
      lastPageConverse: 0,
      interval: null,
      users: [],
      messages: [],
      message: null,
      contact: null,
      typing: false,
      tp: null,
      isImage: null,
      isVideo: null,
      imageFile: [],
      videoFile: [],
      files: [],
      file: null,
      message_file: null,
      currentIndexImage: null,
      keepKeyboardOpen: false,
      checked1: [],
      checked: [],
      message_id: null,
      userid: "",
      user_name: null,
      texting: null,
      user_image: null,
      messageFile: null,
      messageType: null,
      replyMessage: null,
    };
  },
  methods: {
    remve() {
      this.replyMessage = "";
      this.message_id = "";
      this.userid = "";
      this.user_name = "";
      this.texting = "";
      this.user_image = "";
      this.messageFile = "";
      this.messageType = "";
    },
    closePicker() {
      window.HyreadsEvents.emit(events.CLOSE_ALL_REACTION_PICKERS);
    },
    att() {
      document.querySelector(".new-message-modal").style.display = "none";
      this.checked.forEach((item, index) => {
        axios
          .get(`${this.$store.state.endpoints.friendRequest}${item.id}`, {
            headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          })
          .then(() => {
            this.$store.dispatch("chatList");
            this.$store.dispatch("friendSuggestions");
            console.log();
          });

        axios
          .post(
            `${this.$store.state.endpoints.createMessagesUrl}${item.id}/`,
            {
              message: `Hello (${item.username})
              `,
              sender_id: this.$store.state.authuser.id,
            },
            { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
          )
          .then(() => {
            console.log();
          });
      });

      this.checked = [];
    },
    userIdObj(id, username, image) {
      return { id: id, username: username, image: image };
    },
    userIdObj1(id) {
      return { id: id };
    },
    preventKeyboardFromClosing() {
      if (this.keepKeyboardOpen) this.$refs["roomTextarea3"].focus();
    },
    sendMessageLove() {
      axios
        .post(
          `${this.$store.state.endpoints.createMessagesUrl}${
            this.$store.state.authuser &&
            this.contact.sender.id == this.$store.state.authuser.id
              ? this.contact.receiver.id
              : this.contact.sender.id
          }/`,
          {
            message: "❤️",
            sender_id: this.$store.state.authuser.id,
            user_id: this.userid,
          },
          { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
        )
        .then((response) => {
          this.$store.dispatch("chatList");
        });

      let data = {
        receiver: this.contact.receiver,
        sender: {
          id: this.$store.state.authuser.id,
        },
        text: "❤️",
        created_at: new Date(),
        conversation_id:
          this.$store.state.authuser.id *
          (this.$store.state.authuser &&
          this.contact.sender.id == this.$store.state.authuser.id
            ? this.contact.receiver.id
            : this.contact.sender.id),
      };
      var audio = new Audio(this.dataa.soundurl);
      audio.play();
      this.socket.emit("SEND_MESSAGE", data);
      this.escapeTextarea();
      this.message = null;
    },
    sendMessageThumb() {
      axios
        .post(
          `${this.$store.state.endpoints.createMessagesUrl}${
            this.$store.state.authuser &&
            this.contact.sender.id == this.$store.state.authuser.id
              ? this.contact.receiver.id
              : this.contact.sender.id
          }/`,
          {
            message: "👍",
            sender_id: this.$store.state.authuser.id,
            user_id: this.userid,
          },
          { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
        )
        .then((response) => {
          this.$store.dispatch("chatList");
        });

      let data = {
        receiver: this.contact.receiver,
        sender: {
          id: this.$store.state.authuser.id,
        },
        text: "👍",
        created_at: new Date(),
        conversation_id:
          this.$store.state.authuser.id *
          (this.$store.state.authuser &&
          this.contact.sender.id == this.$store.state.authuser.id
            ? this.contact.receiver.id
            : this.contact.sender.id),
      };
      this.socket.emit("SEND_MESSAGE", data);
      this.escapeTextarea();
      this.message = null;
      var audio = new Audio(this.dataa.soundurl);
      audio.play();
    },
    sendFile() {
      this.$store.state.hide = true;
      let formData = new FormData();
      // message: this.message, sender_id: this.$store.state.authuser.id
      formData.append("message", this.message_file);
      formData.append("sender_id", this.$store.state.authuser.id);
      formData.append("chunk", this.files.length);
      formData.append("message_id", this.message_id),
        formData.append("user_id", this.userid),
        formData.append(
          "discourse_id",
          this.$store.state.authuser &&
            this.contact.sender.id == this.$store.state.authuser.id
            ? this.contact.receiver.id
            : this.contact.sender.id
        );
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        formData.append("files", file);
      }
      axios
        .post(
          `${this.$store.state.endpoints.createMessagesUrl}${
            this.$store.state.authuser &&
            this.contact.sender.id == this.$store.state.authuser.id
              ? this.contact.receiver.id
              : this.contact.sender.id
          }/`,
          formData,
          { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
        )
        .then((response) => {
          let data = {
            id: response.data.id,
            receiver: this.contact.receiver,
            sender: {
              id: this.$store.state.authuser.id,
            },
            text: response.data.text,
            created_at: new Date(),
            images: response.data.images,
            videos: response.data.videos,
            has_video: response.data.has_video,
            has_image: response.data.has_image,
            conversation_id:
              this.$store.state.authuser.id *
              (this.$store.state.authuser &&
              this.contact.sender.id == this.$store.state.authuser.id
                ? this.contact.receiver.id
                : this.contact.sender.id),
          };
          this.socket.emit("SEND_MESSAGE", data);
          this.$store.state.hide = false;
          document.querySelector(".preview-box").style.display = "none";
          this.$store.dispatch("chatList");
        });
      var audio = new Audio(this.dataa.soundurl);
      audio.play();
    },
    alrt() {
      const fileTrigger = document.querySelector("#read-filee");
      fileTrigger.click();
    },
    changeHighlight(currentIndex, image) {
      this.ind = currentIndex;
      this.currentIndexImage = image;
    },
    changeHighlightV(currentIndex, image) {
      this.ind = currentIndex;
      this.currentIndexImage = image;
    },
    closepreview() {
      document.querySelector(".preview-box").style.display = "none";
    },
    async onFileChange(files) {
      document.querySelector(".preview-box").style.display = "block";
      for (var f in files) {
        const file = files[f];
        const fileURL = URL.createObjectURL(file);
        const blobFile = await fetch(fileURL).then((res) => res.blob());
        const typeIndex = file.name.lastIndexOf(".");

        this.file = {
          blob: blobFile,
          name: file.name.substring(0, typeIndex),
          size: file.size,
          type: file.type,
          extension: file.name.substring(typeIndex + 1),
          localUrl: fileURL,
        };

        this.files.push(file);

        this.message_file = file.name;
        // file.name.substring(0, typeIndex);

        if (isImageFile(this.file)) {
          this.imageFile.push(fileURL);
          this.isImage = fileURL;
        } else if (isVideoFile(this.file)) {
          this.videoFile.push(fileURL);
          this.isVideo = fileURL;
        }
      }
    },
    type(data) {
      setTimeout(() => {
        this.socket.emit("typing", {
          conversation_id:
            this.$store.state.authuser.id *
            (this.$store.state.authuser &&
            this.contact.sender.id == this.$store.state.authuser.id
              ? this.contact.receiver.id
              : this.contact.sender.id),
          user_id: this.$store.state.authuser.id,
        });
      }, 100);
    },
    resetTextareaSize() {
      this.message = "";
      if (!this.$refs["roomTextarea3"]) return;
      this.$refs["roomTextarea3"].style.height = "30px";
      this.preventKeyboardFromClosing();
    },
    escapeTextarea() {
      this.resetTextareaSize();
      window.scrollTo(0, 0);
    },
    onChangeInput() {
      this.resizeTextarea();
    },
    resizeTextarea() {
      const el = this.$refs["roomTextarea3"];

      if (!el) return;

      const padding = window
        .getComputedStyle(el, null)
        .getPropertyValue("padding-top")
        .replace("px", "");

      el.style.height = 0;
      el.style.height = el.scrollHeight - padding * 2 + "px";
    },
    scrollToBottom() {
      setTimeout(() => {
        this.$refs.feed.scrollTop =
          this.$refs.feed.scrollHeight - this.$refs.feed.clientHeight;
      }, 50);
    },
    selectedContact(chat) {
      this.messages = [];
      this.contact = chat;
      this.pageConverse = 1;
      window.HyreadsEvents.emit(events.NEW_CONVERSATION);
      this.scrollToBottom();
      axios
        .get(
          `${this.$store.state.endpoints.markSomeAsRead}${
            this.$store.state.authuser &&
            chat.sender.id == this.$store.state.authuser.id
              ? chat.receiver.id
              : chat.sender.id
          }/`,
          {
            headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          }
        )
        .then(() => {
          console.log();
          this.$store.dispatch("chatList");
          this.$store.dispatch("unreadNotifications");
        });
    },
    chatPermission() {
      return chatPermissions();
    },
    getHumanDateLastSeen: function (date) {
      return moment(String(date)).fromNow();
    },
    getHumanDate: function (date) {
      return moment(String(date)).format("h:mm");
    },
    getHumanDateStarted: function (date) {
      return moment(String(date)).format("dddd, MMMM Do YYYY");
    },
    getHumanDateFormatTime: function (date) {
      return moment(String(date)).format("DD/MM/YYYY");
    },
    infiniteHandler($state) {
      setTimeout(() => {
        axios
          .get(
            `${this.$store.state.endpoints.chats}?page=${this.$store.state.page}`,
            {
              headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
            }
          )
          .then((response) => {
            if (response.data.data.length > 0) {
              this.lastPage = response.data.last_page;
              response.data.data.forEach((message) => {
                // this.users.push(message);
                this.$store.state.users.push(message);
              });
              if (this.$store.state.page === response.data.last_page) {
                this.page = response.data.last_page;
                this.chatPermission();
                $state.complete();
              } else {
                this.$store.state.page += 1;
              }
              $state.loaded();
            } else {
              this.$store.state.page = response.data.last_page;
              this.chatPermission();
              $state.complete();
            }
          })
          .catch((e) => console.log(e));
      }, 1000);
    },
    infiniteHandlerConversation($state) {
      setTimeout(() => {
        axios
          .get(
            `${conversation}${
              this.$store.state.authuser &&
              this.contact &&
              this.contact.sender.id == this.$store.state.authuser.id
                ? this.contact.receiver.id
                : this.contact
                ? this.contact.sender.id
                : null
            }/?page=${this.pageConverse}`,
            {
              headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
            }
          )
          .then((response) => {
            if (response.data.data.length > 0) {
              this.lastPageConverse = response.data.last_page;
              response.data.data.forEach((message) => {
                this.messages.unshift(message);
                console.log(message);
              });
              if (this.pageConverse === response.data.last_page) {
                this.pageConverse = response.data.last_page;
                $state.complete();
              } else {
                this.pageConverse += 1;
              }
              $state.loaded();
            } else {
              this.pageConverse = response.data.last_page;
              $state.complete();
            }
          })
          .catch((e) => console.log(e));
      }, 1000);
    },
    newMessage() {
      axios
        .post(
          `${this.$store.state.endpoints.createMessagesUrl}${
            this.$store.state.authuser &&
            this.contact.sender.id == this.$store.state.authuser.id
              ? this.contact.receiver.id
              : this.contact.sender.id
          }/`,
          {
            message: this.message,
            sender_id: this.$store.state.authuser.id,
            message_id: this.message_id,
            user_id: this.userid,
            user_name: this.user_name,
            texting: this.texting,
            user_image: this.user_image,
            messageType:
              this.messageType &&
              this.messageType.image &&
              this.messageType.image.length
                ? "image"
                : this.messageType &&
                  this.messageType.video &&
                  this.messageType.video.length
                ? "video"
                : null,
            messageFile:
              this.messageType &&
              this.messageType.image &&
              this.messageType.image.length
                ? this.imag
                : this.messageType &&
                  this.messageType.video &&
                  this.messageType.video.length
                ? this.vide
                : null,
          },
          { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
        )
        .then((response) => {
          let data = {
            id: response.data.id,
            receiver: this.contact.receiver,
            sender: {
              id: this.$store.state.authuser.id,
            },
            user_id: this.$store.state.authuser.id,
            replies: response.data.replies,
            text: response.data.text,
            created_at: new Date(),
            conversation_id:
              this.$store.state.authuser.id *
              (this.$store.state.authuser &&
              this.contact.sender.id == this.$store.state.authuser.id
                ? this.contact.receiver.id
                : this.contact.sender.id),
          };
          this.socket.emit("SEND_MESSAGE", data);
          this.$store.dispatch("chatList");
        });

      let data = {
        id: null,
        receiver: this.contact.receiver,
        sender: {
          id: this.$store.state.authuser.id,
        },
        user_id: this.$store.state.authuser.id,
        replies: null,
        text: this.message,
        created_at: new Date(),
        conversation_id:
          this.$store.state.authuser.id *
          (this.$store.state.authuser &&
          this.contact.sender.id == this.$store.state.authuser.id
            ? this.contact.receiver.id
            : this.contact.sender.id),
      };
      if (!this.replyMessage) {
        this.messages.push(data);
      }
      this.scrollToBottom();
      this.escapeTextarea();
      this.message = null;
      this.messageType = null;
      this.replyMessage = null;
      this.userid = "";
      var audio = new Audio(this.dataa.soundurl);
      audio.play();
      document.querySelector(".popping-box1").style.display = "none";
    },
    sendMessage() {
      axios
        .post(
          `${this.$store.state.endpoints.createMessagesUrl}${this.$route.params.id}/`,
          {
            message: this.message,
            sender_id: this.$store.state.authuser.id,
          },
          { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
        )
        .then(() => {
          console.log();
          this.$store.dispatch("chatList");
        });
      this.socket.emit("SEND_MESSAGE", {
        user: this.$store.state.authuser.username,
        message: this.message,
        conversation_id:
          this.$store.state.authuser.id * this.contact.receiver.id,
      });
    },
  },
  computed: {
    sortedContacts() {
      if (this.search) {
        return this.$store.state.users.filter((item) => {
          return this.$store.state.authuser &&
            item.sender.id == this.$store.state.authuser.id
            ? item.receiver.username
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1
            : item.sender.username
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1;
        });
      } else {
        return this.$store.state.users;
      }
    },
  },
  watch: {
    messages(messages) {
      this.scrollToBottom();
    },
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  created() {},
  mounted() {
    window.HyreadsEvents.on(events.DELETE_MESSAGE, (respons) => {
      axios
        .post(
          `${this.$store.state.endpoints.chatDelete}`,
          {
            message_id: respons.message.id,
          },
          { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
        )
        .then((response) => {
          this.$store.dispatch("chatList");
          let data = {
            index: respons.message.index,
            conversation_id:
              this.$store.state.authuser.id *
              (this.$store.state.authuser &&
              this.contact.sender.id == this.$store.state.authuser.id
                ? this.contact.receiver.id
                : this.contact.sender.id),
          };
          this.socket.emit("DELETE_MESSAGE", data);
        });

      this.messages[respons.message.index].deletes = [
        this.messages[respons.message.index],
      ];

      console.log("response", respons.message);
    });
    window.HyreadsEvents.on(events.NEW_REPLY, (response) => {
      document.querySelector(".replybox").click();
      console.log("response", response.message.text);
      this.replyMessage = response.message.text;
      this.messageType = {
        image: response.message.images,
        video: response.message.videos,
      };
      this.imag = response.message.images
        ? response.message.images[0].fields.filename
        : null;
      this.vide = response.message.videos
        ? response.message.videos[0].fields.filename
        : null;
      this.message_id = response.message.id;
      this.userid =
        this.$store.state.authuser &&
        response.message.sender &&
        response.message.sender.id == this.$store.state.authuser.id
          ? response.message.receiver.id
          : response.message.sender.id;
      this.user_name =
        this.$store.state.authuser &&
        response.message.sender &&
        response.message.sender.id == this.$store.state.authuser.id
          ? response.message.receiver.username
          : response.message.sender.username;
      this.texting = response.message.text;
      this.user_image =
        this.$store.state.authuser &&
        response.message.sender &&
        response.message.sender.id == this.$store.state.authuser.id
          ? response.message.receiver.image
          : response.message.sender.image;

      console.log("messageType", this.imag);
    });
    window.HyreadsEvents.on(events.REACTION_CHANGED, (data) => {
      axios
        .post(
          `${this.$store.state.endpoints.chatReact}`,
          {
            message_id: data.message.message_id,
            emoji: data.message.emoji,
            name: data.message.name,
          },
          { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
        )
        .then((response) => {
          // this.$store.dispatch("chatList");

          this.socket.emit("REACT_MESSAGE", data);
        });
      if (this.messages[data.message.index].reacts != null) {
        const check = this.messages[data.message.index].reacts.find(
          (item) => item.reaction === data.message.emoji
        );

        if (check) {
          check.total++;
        } else {
          this.messages[data.message.index].reacts.push({
            message_id: data.message.message_id,
            reaction: data.message.emoji,
            total: 1,
          });
        }
      } else {
        this.messages[data.message.index].reacts = [
          {
            message_id: data.message.message_id,
            reaction: data.message.emoji,
            total: 1,
          },
        ];
      }

      var audio = new Audio(this.dataa.soundurl);
      audio.play();

      console.log("data", data);
    });
    window.HyreadsEvents.on(events.EMOJI_CHANGED, (emoji) => {
      axios
        .post(
          `${this.$store.state.endpoints.createMessagesUrl}${
            this.$store.state.authuser &&
            this.contact.sender.id == this.$store.state.authuser.id
              ? this.contact.receiver.id
              : this.contact.sender.id
          }/`,
          {
            message: emoji.emoji,
            sender_id: this.$store.state.authuser.id,
            user_id: this.userid,
          },
          { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
        )
        .then((response) => {
          this.$store.dispatch("chatList");
        });

      let data = {
        receiver: this.contact.receiver,
        sender: {
          id: this.$store.state.authuser.id,
        },
        text: emoji.emoji,
        created_at: new Date(),
        conversation_id:
          this.$store.state.authuser.id *
          (this.$store.state.authuser &&
          this.contact.sender.id == this.$store.state.authuser.id
            ? this.contact.receiver.id
            : this.contact.sender.id),
      };
      var audio = new Audio(this.dataa.soundurl);
      audio.play();
      this.socket.emit("SEND_MESSAGE", data);
      this.escapeTextarea();
      this.message = null;
    });
    window.HyreadsEvents.on(events.NEW_CONVERSATION, (error) => {
      console.log("NEW_CONVERSATION", error);
      this.$refs.infiniteLoadingConverse.stateChanger.reset();
      this.socket.emit(
        "user_connected",
        this.$store.state.authuser.id * this.contact.receiver.id
      );
    });

    //opening emoji box
    const emoji_box1 = document.querySelector(".popping-box1");
    const emoji_btn1 = document.querySelector(".replybox");
    const close_emojis1 = document.querySelector(".close-emojis1");

    emoji_btn1.addEventListener("click", () => {
      if ((emoji_box1.style.display = "none")) {
        emoji_box1.style.display = "block";
      }
      emoji_box1.classList.toggle("show");
    });
    close_emojis1.addEventListener("click", () => {
      emoji_box1.style.display = "none";
    });
    //new message modal
    const message_modal_trigger = document.querySelectorAll(".fire-modal");
    const message_cancel_btn = document.querySelector(
      ".btns-events .btn-cancel"
    );
    const message_modal_container =
      document.querySelector(".new-message-modal");
    const message_modal_content = document.querySelector(
      ".message-modal-content"
    );

    message_modal_trigger.forEach((item) => {
      if (item) {
        item.addEventListener("click", () => {
          message_modal_container.style.display = "flex";
        });
      }
    });
    if (message_cancel_btn) {
      message_cancel_btn.addEventListener("click", () => {
        message_modal_container.style.display = "none";
      });
    }
    document.addEventListener("mouseup", (e) => {
      if (!message_modal_content.contains(e.target)) {
        message_modal_container.style.display = "none";
      }
    });
    const fileTrigger = document.querySelector("#read-filee");
    const fileBtn = document.getElementById("open-uploadid");
    fileBtn.addEventListener("click", () => {
      fileTrigger.click();

      fileTrigger.addEventListener("change", function () {
        const file = this.files[0];
      });
    });
    this.$refs["roomTextarea3"].addEventListener("click", () => {
      if (isMobile) this.keepKeyboardOpen = true;
    });

    this.$refs["roomTextarea3"].addEventListener("blur", () => {
      if (isMobile) setTimeout(() => (this.keepKeyboardOpen = false), 0);
    });

    this.interval = setInterval(() => {
      this.chatPermission();
    }, 1000);
    this.socket.on("typing", (data) => {
      if (
        data.conversation_id ===
          this.$store.state.authuser.id *
            (this.$store.state.authuser &&
            this.contact.sender.id == this.$store.state.authuser.id
              ? this.contact.receiver.id
              : this.contact.sender.id) &&
        data.user_id != this.$store.state.authuser.id
      ) {
        this.scrollToBottom();
        this.typing = true;
        // this.contact.receiver.online = "Online";
        // this.contact.sender.online = "Online";
        // clearTimeout(this.tp);
        this.tp = setTimeout(() => {
          // _this.online = true;
          this.typing = false;
          this.scrollToBottom();
        }, 5000);
      }
    });

    this.socket.on(`REACT__MESSAGE`, (data) => {
      if (this.messages[data.message.index].reacts != null) {
        const check = this.messages[data.message.index].reacts.find(
          (item) => item.reaction === data.message.emoji
        );

        if (check && data.message.user_id != this.$store.state.authuser.id) {
          check.total++;
        } else if (
          !check &&
          data.message.user_id != this.$store.state.authuser.id
        ) {
          this.messages[data.message.index].reacts.push({
            message_id: data.message.message_id,
            reaction: data.message.emoji,
            total: 1,
          });
        }
      } else if (data.message.user_id != this.$store.state.authuser.id) {
        this.messages[data.message.index].reacts = [
          {
            message_id: data.message.message_id,
            reaction: data.message.emoji,
            total: 1,
          },
        ];
      }
      if (data.message.user_id != this.$store.state.authuser.id) {
        var audio = new Audio(this.dataa.soundurl);
        audio.play();
      }

      console.log("react_data", data);
    });

    this.socket.on(`DELETE__MESSAGE`, (data) => {
      if (
        data.conversation_id ===
        this.$store.state.authuser.id *
          (this.$store.state.authuser &&
          this.contact.sender.id == this.$store.state.authuser.id
            ? this.contact.receiver.id
            : this.contact.sender.id)
      ) {
        this.messages[data.index].deletes = [this.messages[data.index]];
        console.log("deletedmessae", data);
      }
    });
    this.socket.on(`MESSAGE`, (data) => {
      // this.messages = [...this.messages, data];
      if (
        data.conversation_id ===
          this.$store.state.authuser.id *
            (this.$store.state.authuser &&
            this.contact.sender.id == this.$store.state.authuser.id
              ? this.contact.receiver.id
              : this.contact.sender.id) &&
        data.user_id != this.$store.state.authuser.id
      ) {
        this.messages.push(data);
        this.scrollToBottom();
        this.$store.dispatch("chatList");
        console.log("data", data);
      }
    });
    window.addEventListener("keydown", (e) => {
      if (e.key === "Backspace" || e.key === "Delete") {
        this.resizeTextarea();
      }
    });

    const isMobile = detectMobile();

    window.addEventListener("keyup", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        if (isMobile) {
          this.message = this.message + "\n";
          setTimeout(() => this.onChangeInput(), 0);
        } else {
          this.newMessage();
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/font-opensans.css";
@import "../../styles/font-fresca.css";
@import "../../styles/font-quicksand.css";
@import "../../styles/font-poppins.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
body {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}
.inner-row {
  width: 90%;
  margin: auto;
}
.profile-image {
  width: 2.4rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
}
img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.action-effectors img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.chatroom-wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}

.chatroom-wrapper .left-part {
  width: 400px;
  height: 100%;
  z-index: 997;
  border-right: 1px solid gainsboro;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
}
.chatroom-wrapper .left-part.hide-container {
  left: -100%;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
}
.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: rgb(250, 250, 250);
}
.top-header .action-effectors {
  display: flex;
  gap: 30px;
  margin-right: 20px;
}

.adjacent-search-bar {
  margin: 5px 15px;
  padding: 8px;
  border-radius: 25px;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  -ms-border-radius: 25px;
  -o-border-radius: 25px;
  background-color: rgb(248, 248, 248);
  display: flex;
  gap: 10px;
}
.adjacent-search-bar span {
  color: #444;
}
.adjacent-search-bar .search-control {
  font-size: 14px;
  outline: none;
  font-family: "Quicksand";
  border: none;
  width: 80%;
  background: transparent;
}
.adjacent-search-bar .cancel {
  font-size: 20px;
  display: none;
  cursor: pointer;
  color: rgb(0, 102, 255);
}

.chat-options-wrapper {
  border-top: 1px solid gainsboro;
  height: 100%;
  margin: auto;
  overflow-y: scroll;
  scrollbar-width: thin;
  padding-bottom: 150px;
}

.specific-chat {
  display: flex;
  gap: 6px;
  align-items: center;
  border-bottom: 1px solid gainsboro;
  cursor: pointer;
  padding: 5px 10px;
}
.specific-chat:hover {
  background: rgb(241, 241, 241);
}
.specific-chat .chat-profile-image {
  width: 2.6rem;
  width: 2.6rem;
  aspect-ratio: 1/1;
  display: block;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
}
.chat-profile-image img {
  border-radius: 50%;
  display: block;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}
.chat-content {
  width: 100%;
  padding: 5px 0;
  margin-bottom: 10px;
}
.chat-content .chat-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chat-name h4 {
  font-size: 16px;
  color: #333;
}
.chat-name p {
  font-weight: 400;
  font-size: 12px;
}
.chat-body {
  display: flex;
  margin-top: 5px;
  align-items: center;
  gap: 2px;
}
.chat-body p {
  font-size: 14px;
  padding-top: 4px;
}

.right-part {
  position: relative;
  margin-left: 400px;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.right-part .main-body {
  width: 100%;
}
.right-top-header {
  padding: 10px 15px;
  background: rgb(245, 245, 245);
  border-bottom: 1px solid gainsboro;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.right-top-header span.exchange {
  font-size: 25px;
  cursor: pointer;
  display: none;
}
.right-top-header .top-header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.right-top-header .responder-profile {
  display: flex;
  gap: 0.5rem;
}
.responder-profile .profile-image {
  width: 40px;
  height: 40px;
}
.responder-name p {
  font-size: 12px;
  color: #444;
}
.responder-name h4 {
  font-size: 16px;
  font-weight: 600;
}
.responder-actions {
  display: flex;
  gap: 30px;
  position: relative;
}
.responder-actions span {
  font-size: 20px;
  cursor: pointer;
}

.responder-profile .profile-image1 {
  width: 180px;
  height: 180px;
}
.profile-image1 {
  margin-right: auto;
  width: 90px;
  height: 90px;
  margin-left: auto;
  border-radius: 50%;
}
.profile-image1 img {
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;

  box-shadow: 0px 0px 1px 1px gainsboro;
}

.responder-actions .mobile-options1 {
  position: absolute;
  top: -18px;
  right: -15px;
  z-index: 88;
  width: 100vw;
  height: 100vh;
  background: rgb(245, 245, 245);
  border: 1px solid gainsboro;
  display: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

.mobile-options1 span {
  display: block;
  font-size: 14px;
  padding: 10px;
}
.mobile-options1 span:hover {
  background: rgb(238, 238, 238);
}
.responder-actions .mobile-options {
  position: absolute;
  right: 25px;
  z-index: 88;
  width: 150px;
  height: auto;
  background: rgb(245, 245, 245);
  border: 1px solid gainsboro;
  display: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

.mobile-options span {
  display: block;
  font-size: 14px;
  padding: 10px;
}
.mobile-options span:hover {
  background: rgb(238, 238, 238);
}
.search-messages {
  position: relative;
  width: 500px;
  margin-right: -150%;
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
  border-left: 1px solid gainsboro;
}
.search-messages.show {
  position: relative;
  width: 500px;
  margin-right: 0;
}
.search-messages-top-bar {
  padding: 14px 5px;
  justify-content: left;
  gap: 0.5rem;
}
.search-messages-top-bar span {
  font-size: 25px;
  cursor: pointer;
}
.search-messages-top-bar h4 {
  font-weight: 500;
}

.search-messages p {
  font-size: 12px;
  text-align: center;
  color: #444;
  margin-top: 20px;
}
.default-face {
  position: absolute;
  top: 0;
  left: 0;
  background: rgb(233, 244, 250);
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.default-face-content {
  width: 60%;
  height: max-content;
  text-align: center;
  color: #333;
}

.default-face-content .image-default {
  width: 300px;
  margin: auto;
}
.default-face-content h2 {
  font-size: 35px;
  font-family: "Poppins";
}
.default-face-content h4 {
  font-size: 20px;
}
.default-face-content p {
  margin-bottom: 20px;
}

.default-face-content button {
  background: rgb(0, 102, 255);
  padding: 10px 30px;
  font-size: 15px;
  font-family: "Quicksand";
  color: white;
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  -ms-border-radius: 30px;
  -o-border-radius: 30px;
  border: none;
  cursor: pointer;
}

.chat-section {
  background: #fff;
  width: 100%;
  height: 90.8vh;
  position: relative;
}

.chat-input {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgb(247, 247, 247);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  width: 100%;
}

.chat-actions {
  display: flex;
  gap: 10px;
}
.chat-input span {
  font-size: 25px;
  cursor: pointer;
  color: #333;
}
.send-actions .microphone:hover {
  color: rgb(0, 60, 255);
}
.send-actions .send {
  display: block;
}
.chat-insert {
  width: 80%;
  margin-right: 32px;
  margin-left: 0px;
}
.chat-insert .insert-control {
  width: 100%;
  outline: none;
  padding: 12px;
  border-radius: 25px;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  -ms-border-radius: 25px;
  -o-border-radius: 25px;
  border: 1px solid gainsboro;
  font-family: "Quicksand";
  font-size: 15px;
  height: 45px;
  resize: none;
}

.chat-insert .insert-control1 {
  width: 100%;
  outline: none;
  padding: 12px;
  border-radius: 25px;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  -ms-border-radius: 25px;
  -o-border-radius: 25px;
  border: 1px solid gainsboro;
  font-family: "Quicksand";
  font-size: 15px;
  height: 45px;
  resize: none;
}

.messages-themselfu {
  width: 96%;
  height: 80vh;
  margin: auto;
  padding: 20px 0;
  overflow-y: scroll;
  scrollbar-width: none;
}
.messages-title p {
  text-align: center;
  font-size: 11px;
  color: #222;
  margin-bottom: 30px;
}

.message {
  display: flex;
  margin: 3px;
  margin-top: 20px;
}
.message p {
  padding: 8px 16px;
}
.message .message-details {
  max-width: 400px;
  position: relative;
  margin-top: 30px;
}
.message.inquire .message-details {
  margin-left: auto;
  border-radius: 18px 18px 0px 18px;
  -webkit-border-radius: 18px 18px 0px 18px;
  -moz-border-radius: 18px 18px 0px 18px;
  -ms-border-radius: 18px 18px 0px 18px;
  -o-border-radius: 18px 18px 18px 0px;
  background: #50b5ff;
}
.message.inquire .message-details p {
  color: white;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
}
.message.reply .message-details {
  background: #e0e0e0;
  border-radius: 18px 18px 18px 0px;
  -webkit-border-radius: 18px 18px 18px 0px;
  -moz-border-radius: 18px 18px 18px 0px;
  -ms-border-radius: 18px 18px 18px 0px;
  -o-border-radius: 18px 18px 18px 0px;
}
.message.reply .message-details p {
  color: black;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
}
.time-of-post {
  position: absolute;
  right: 0;
  bottom: 0;
  color: #444;
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin: 5px;
}
.message.inquire .time-of-post span.time {
  color: #fff;
}
.time-of-post span.time {
  font-size: 11px;
}

.new-message-modal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
  z-index: 999;
}
.new-message-modal .message-modal-content {
  width: 500px;
  background: #fff;
  border-radius: 5px;
  padding: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0px 0px 3px 1px rgb(218, 218, 218);
}

.new-message-modal1 {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
  z-index: 9999;
}
.new-message-modal1 .message-modal-content1 {
  width: 500px;
  background: #fff;
  border-radius: 5px;
  padding: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0px 0px 3px 1px rgb(218, 218, 218);
}
.message-modal-content .title {
  font-family: "Poppins";
  margin-bottom: 10px;
}

.message-modal-content1 .title {
  font-family: "Poppins";
  margin-bottom: 10px;
}
.modal-search-contact {
  width: 100%;
  padding: 10px;
  background: whitesmoke;
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  -ms-border-radius: 30px;
  -o-border-radius: 30px;
}
.message-modal-content hr {
  border: none;
  border-bottom: 1px solid gainsboro;
  margin: 15px auto;
}

.message-modal-content1 hr {
  border: none;
  border-bottom: 1px solid gainsboro;
  margin: 15px auto;
}
.modal-search-contact .search-control {
  width: 80%;
  outline: none;
  border: none;
  font-size: 15px;
  font-family: "Quicksand";
  background: transparent;
}

.person-account {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.person-profile {
  display: flex;
  gap: 5px;
  align-items: center;
}
.person-account h3 {
  font-size: 16px;
}
.person-account p {
  font-weight: 100;
  font-size: 13px;
}
.btns-events {
  text-align: center;
  margin: 20px auto;
}
.btns-events .btn {
  padding: 8px 30px;
  font-family: "Quicksand";
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  -ms-border-radius: 30px;
  -o-border-radius: 30px;
  border: none;
  color: white;
  cursor: pointer;
}
.btns-events1 {
  text-align: center;
  margin: 20px auto;
}

.options-btn1 {
  display: none;
}
.btns-events1 .btn {
  padding: 8px 30px;
  font-family: "Quicksand";
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  -ms-border-radius: 30px;
  -o-border-radius: 30px;
  border: none;
  color: white;
  cursor: pointer;
}
.btns-events .btn-cancel {
  background: rgb(236, 38, 38);
}

.btns-events1 .btn-cancel1 {
  background: rgb(236, 38, 38);
}
.btns-events .btn-submit {
  background: rgb(0, 102, 255);
}
.btns-events1 .btn-submit1 {
  background: rgb(0, 102, 255);
}
@media (max-width: 1000px) {
  .message.reply .message-details {
    margin-right: 30px;
    max-width: 500px;
  }
  .message.inquire .message-details {
    // margin-left:30px;
    max-width: 500px;
    justify-content: flex-end;
  }
  .search-chat {
    display: none;
  }
  .search-messages {
    display: none;
  }
}

@media (max-width: 780px) {
  .message.reply .message-details {
    margin-right: 30px;
    max-width: 500px;
  }
  .message.inquire .message-details {
    // margin-left:30px;
    max-width: 500px;
    justify-content: flex-end;
  }
}

/* Responsivity */
@media (max-width: 780px) {
  .chatroom-wrapper .left-part {
    width: 100%;
    right: 0;
    z-index: 2;
    background: white;
  }
  .chatroom-wrapper .right-part {
    margin-left: 0;
  }
}
@media (max-width: 550px) {
  .new-message-modal .message-modal-content {
    width: 90%;
    margin: auto;
  }

  .new-message-modal1 .message-modal-content {
    width: 90%;
    margin: auto;
  }
}
@media (max-width: 415px) {
  .specific-chat .chat-profile-image {
    width: 2.6rem;
    width: 2.6rem;
  }
  .chat-name h4 {
    font-size: 14px;
  }
  .chat-name p {
    font-size: 10px;
  }
  .right-top-header {
    gap: 5px;
  }
  .responder-name h4 {
    font-weight: 500;
    font-size: 15px;
  }
  .message-details p {
    font-size: 12px !important;
  }

  .search-chat {
    display: none;
  }

  .options-btn {
    display: none;
  }

  .options-btn1 {
    display: block;
  }

  .responder-actions .mobile-options1 {
    position: absolute;
    top: -18px;
    right: -15px;
    z-index: 88;
    width: 100vw;
    height: 100vh;
    background: rgb(245, 245, 245);
    border: 1px solid gainsboro;
    display: block;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
  }
}

.popping-box {
  width: 100%;
  height: 300px;
  position: absolute;
  left: 0;
  bottom: 65px;
  right: 0;
  background: #fff;
  border-top: 1px solid gainsboro;
  display: none;
  z-index: 999;
}
.popping-box.show {
  width: 100%;
  height: 300px;
  position: absolute;
  left: 0;
  bottom: 65px;
  right: 0;
  background: #fff;
  border-top: 1px solid gainsboro;
  display: block;
}
.popping-inner {
  position: relative;
  width: 100%;
}
.close-emojis {
  // font-size:20px;
  // position:absolute;
  // right:10px;
  // top:5px;
  cursor: pointer;
}

.popping-box1 {
  width: 100%;
  height: 50px;
  position: absolute;
  left: 0;
  bottom: 65px;
  right: 0;
  background: #fff;
  border-top: 1px solid gainsboro;
  display: none;
}
.popping-box1.show {
  width: 100%;
  height: 50px;
  position: absolute;
  left: 0;
  bottom: 65px;
  right: 0;
  background: #fff;
  border-top: 1px solid gainsboro;
  display: block;
}
.popping-inner1 {
  position: relative;
  width: 100%;
}
.close-emojis1 {
  font-size: 20px;
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}

.text {
  overflow: hidden; /* Essential */
  width: 240px;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 16px; /* Essential */
  max-height: 20px; /* Multiples of line-height */
}

.vac-card-info {
  border-radius: 4px;
  text-align: center;
  margin: 10px auto;
  font-size: 12px;
  padding: 4px;
  display: block;
  overflow-wrap: break-word;
  position: relative;
  white-space: normal;
  box-shadow: 0 1px 1px -1px rgba(0, 0, 0, 0.1),
    0 1px 1px -1px rgba(0, 0, 0, 0.11), 0 1px 2px -1px rgba(0, 0, 0, 0.11);
}

.vac-card-date {
  max-width: 150px;
  font-weight: 13;
  font-style: italic;
  text-transform: uppercase;
  color: var(--chat-message-color-date);
  background: var(--chat-message-bg-color-date);
}
.open-emojis:hover {
  color: rgb(0, 60, 255);
}
.vac-icon-check {
  height: 14px;
  width: 14px;
  // vertical-align: middle;
  // margin: -3px -3px 0 3px;
}
.seen {
  fill: #49f0d3;
}

.deskcall {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 19999;
}
@media (max-width: 992px) {
  .deskcall {
    position: absolute;
    bottom: 40px;
    right: 10px;
    z-index: 19999;
  }
}
.video-container {
  height: 100vh;
  margin: 0 auto;
  /* border: 1px solid #0acf83; */
  position: relative;
  /* box-shadow: 1px 1px 11px #9e9e9e; */
  background-color: #182028;
}

.video-container .user-video {
  width: 30%;
  position: absolute;
  left: 10px;
  bottom: 10px;
  border: 1px solid #fff;
  border-radius: 6px;
  z-index: 2;
}
@media (max-width: 992px) {
  .video-container .user-video {
    width: 50%;
    position: absolute;
    left: 10px;
    bottom: 110px;
    border: 1px solid #fff;
    border-radius: 6px;
    z-index: 2;
  }
}
.video-container .partner-video {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
  margin: 0;
  padding: 0;
}

.calls-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.calls-content {
  text-align: center;
}
.calls-content h4 {
  font-size: 24px;
  margin: 5px 0;
  color: #fff;
}
.calls-content p {
  font-size: 15px;
  color: white;
  margin-bottom: 20px;
}

.caller-image {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  object-fit: cover;
  margin: 50px 0;
}
.caller-image img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  object-fit: cover;
}
.call-action-btns {
  margin-top: 30px;
  display: flex;
  gap: 10px;
}
.call-action-btns span {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  background: white;
  cursor: pointer;
}

.call-action-btns span img {
  width: 25px;
  height: 25px;
}
.microphone-icon img.show-onclick,
.video img.show-onclick {
  display: none;
}
.microphone-icon.switch img.show-onclick,
.video.switch img.show-onclick {
  display: block;
}
.microphone-icon.switch img.default,
.video.switch img.default {
  display: none;
}

.preview-box {
  background: whitesmoke;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 20px;
  z-index: 2;
  display: none;
}
.preview-box-inner {
  width: 98%;
  margin: 5px;
  position: relative;
}
.preview-box .close-preview {
  font-size: 24px;
  cursor: pointer;
}
.preview-box .preview-file {
  width: 60%;
  // border:1px solid;
  height: 250px;
  margin: 5px auto;
}
.preview-box .insert-control {
  width: 70%;
  display: block;
  margin: 3px auto;
  outline: none;
  padding: 12px;
  border-radius: 25px;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  -ms-border-radius: 25px;
  -o-border-radius: 25px;
  border: 1px solid gainsboro;
  font-family: "Quicksand";
  font-size: 15px;
  height: 45px;
  resize: none;
}

.preview-box .insert-control1 {
  width: 70%;
  display: block;
  margin: 3px auto;
  outline: none;
  padding: 12px;
  border-radius: 25px;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  -ms-border-radius: 25px;
  -o-border-radius: 25px;
  border: 1px solid gainsboro;
  font-family: "Quicksand";
  font-size: 15px;
  height: 45px;
  resize: none;
}
.preview-box hr {
  border: none;
  border-bottom: 1px solid gainsboro;
}
.send-btn {
  // margin-top: 0px;
  // position:relative;
  right: 0;
  /* position: absolute; */
  bottom: 59px;
  position: absolute;
}
.send-btn span {
  font-size: 25px;
  width: 60px;
  height: 60px;
  display: flex;
  color: white;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  background-color: rgb(29, 127, 255);
  position: absolute;
  right: 0;
  cursor: pointer;
}
@media (max-width: 600px) {
  .preview-box .preview-file {
    width: 90%;
    height: 50%;
  }
  .preview-box .insert-control {
    width: 90%;
    resize: none;
  }

  .preview-box .insert-control1 {
    width: 90%;
    resize: none;
  }
}

.vac-media-container {
  z-index: -1;
}
.vac-icon-media {
  display: flex;
  justify-content: flex-end;
  position: absolute;

  // justify-content:flex-end;
  z-index: 10;

  svg {
    height: 30px;
    width: 30px;
    border-radius: 50%;
  }

  &:before {
    content: " ";
    position: absolute;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
  }
}
.vac-media-file {
  width: 100%;
  height: 100%;
  max-height: 300px;
  overflow: scroll;
  // margin:1rem 0;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  display: grid;
  grid-template-columns: auto auto auto auto;

  img {
    border-radius: 15px;
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }

  video {
    border-radius: 15px;
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 600px) {
    img {
      border-radius: 15px;
      width: 100%;
      // max-width: 100%;
      height: 90%;
      object-fit: cover;
    }

    video {
      border-radius: 15px;
      width: 100%;
      max-width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.preview-input-box {
  margin-top: 2rem !important;
  padding-top: 2rem !important;
}

@media (max-width: 600px) {
  .preview-input-box {
    margin-top: 0px !important;
    padding-top: 0px !important;
  }
}

.image-list-container {
  max-width: 190px;
  min-height: 50px;
  margin-top: 10px;
}
.image-list-container .image-list-item {
  height: 32px;
  width: 32px;
  border-radius: 4px;
  border: 1px solid #d6d6d6;
}
.image-list-container .image-list-item:not(:last-child) {
  margin-right: 10px;
  margin-bottom: 10px;
}
.image-list-container .image-list-item .show-img {
  max-width: 25px;
  max-height: 17px;
}
.image-list-container .image-highlight {
  border: 1px solid #2fa3e7;
}
.display-flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}
.justify-content-center {
  justify-content: center;
}
.justify-content-between {
  justify-content: space-between;
}
.justify-content-end {
  justify-content: flex-end;
}

.img-responsive {
  display: block;
  max-width: 100%;
  height: auto;
}
.show-img {
  max-height: 100px;
  max-width: 140px;
  display: block;
}

.centered {
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  position: absolute;
  display: block;
}

/*Video Styling*/

.video-container {
  width: 100%;
  height: 100vh;
  background: #222;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
}

.video-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  width: 90%;
  padding: 20px 0;
}

.video-content .video-grid {
  width: 100%;
  height: 350px;
}
.video-grid .voice-call {
  height: 100%;
  display: none;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 10px;
  background: rgba(29, 29, 29, 0.603);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}
.video-grid .user-profile {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  box-shadow: 0px 0px 2px 1px gainsboro;
}
.video-grid .user-profile img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}
.video-grid p {
  position: absolute;
  left: 10px;
  bottom: 10px;
  color: #fff;
  font-size: 15px;
}

.micro-off {
  width: 30px;
  height: 30px;
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  background: whitesmoke;
}
.micro-off img {
  width: 15px;
  height: 15px;
}

.video-grid.switch .video-call {
  display: none;
}
.video-grid.switch .voice-call {
  display: flex;
}
.video-call {
  height: inherit;
  display: block;
}
.video-call img {
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  object-fit: cover;
}
@media (max-width: 900px) {
  .video-container {
    height: 120vh;
  }
  .video-content {
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
  }
  .video-content .video-grid {
    height: 280px;
    width: 400px;
    margin: auto;
  }
}
@media (max-width: 480px) {
  .video-content .video-grid {
    width: 100%;
  }
}

.action-btns {
  position: absolute;
  display: flex;
  bottom: 20px;
  gap: 20px;
}
.action-btns span {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: whitesmoke;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  cursor: pointer;
}
.action-btns span img {
  width: 20px;
  height: 20px;
}
.vac-media-file1 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 30px;

  img {
    border-radius: 15px;
    width: 100%;
    max-width: 150px;
    max-height: 100%;
  }

  video {
    border-radius: 15px;
    width: 100%;
    max-width: 250px;
    max-height: 100%;
  }
}
.post-photo {
  overflow: hidden;
  margin: 0 0;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}

/* here is the extra-actions styles */
.message .extra-actions {
  width: 120px;
  position: absolute;
  bottom: -100px;
  right: 50px;
  background: rgb(255, 255, 255);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0px 0px 2px 1px gainsboro;
  z-index: 888;
}

.message .extra-actions1 {
  width: 120px;
  position: absolute;
  bottom: -100px;
  left: 50px;
  background: rgb(255, 255, 255);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0px 0px 2px 1px gainsboro;
  z-index: 888;
}

.message .extra-actions span {
  display: block;
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
}
.extra-actions span:hover {
  background: rgb(230, 230, 230);
}

.message .extra-actions1 span {
  display: block;
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
}
.extra-actions1 span:hover {
  background: rgb(230, 230, 230);
}
/* end of stylling */

.message.inquire .actions1 {
  border-radius: 25px;
  background-color: transparent;
  display: block;
  width: 20px;
  position: absolute;
  bottom: -26px;
  right: 1;
}

.message.reply .actions1 {
  border-radius: 25px;
  background-color: #e0e0e0;
  display: block;
  width: fit-content;
  position: absolute;
  bottom: -26px;
  right: 0;
}

.vac-icon-textarea-left {
  display: flex;
  align-items: center;
  margin-right: 5px;

  svg,
  .vac-wrapper {
    margin: 0 7px;
  }

  .vac-icon-microphone {
    fill: var(--chat-icon-color-microphone);
    margin: 0 7px;
  }

  .vac-dot-audio-record {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #eb4034;
    animation: vac-scaling 0.8s ease-in-out infinite alternate;

    @keyframes vac-scaling {
      0% {
        transform: scale(1);
        opacity: 0.4;
      }
      100% {
        transform: scale(1.1);
        opacity: 1;
      }
    }
  }

  .vac-dot-audio-record-time {
    font-size: 16px;
    color: var(--chat-color);
    margin-left: 8px;
    width: 45px;
  }

  .vac-icon-audio-stop,
  .vac-icon-audio-stop {
    margin-right: 20px;

    #vac-icon-close-outline {
      fill: var(--chat-icon-color-audio-cancel);
    }
  }

  .vac-icon-audio-confirm {
    margin-right: 3px;
    margin-left: 12px;

    #vac-icon-checkmark {
      fill: var(--chat-icon-color-audio-confirm);
    }
  }
}

.vac-col-messages {
  position: relative;
  height: 100%;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-flow: column;

  .vac-container-center {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .vac-room-empty {
    font-size: 14px;
    color: #9ca6af;
    font-style: italic;
    line-height: 20px;
    white-space: pre-line;

    div {
      padding: 0 10%;
    }
  }

  .vac-container-scroll {
    background: var(--chat-content-bg-color);
    flex: 1;
    overflow-y: auto;
    margin-right: 1px;
    margin-top: 60px;
    -webkit-overflow-scrolling: touch;

    &.vac-scroll-smooth {
      scroll-behavior: smooth;
    }
  }

  .vac-messages-container {
    padding: 0 5px 5px;
  }

  .vac-text-started {
    font-size: 14px;
    color: var(--chat-message-color-started);
    font-style: italic;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .vac-icon-scroll {
    position: absolute;
    bottom: 80px;
    right: 20px;
    padding: 8px;
    background: var(--chat-bg-scroll-icon);
    border-radius: 50%;
    box-shadow: 0 1px 1px -1px rgba(0, 0, 0, 0.2),
      0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 2px 0 rgba(0, 0, 0, 0.12);
    display: flex;
    cursor: pointer;
    z-index: 10;

    svg {
      height: 25px;
      width: 25px;
    }
  }

  .vac-messages-count {
    position: absolute;
    top: -8px;
    left: 11px;
    background-color: var(--chat-message-bg-color-scroll-counter);
    color: var(--chat-message-color-scroll-counter);
  }

  .vac-room-footer {
    width: 100%;
    border-bottom-right-radius: 4px;
    z-index: 10;
  }

  .vac-box-footer {
    display: flex;
    position: relative;
    background: var(--chat-footer-bg-color);
    padding: 10px 8px 10px;
  }

  .vac-textarea {
    height: 20px;
    width: 100%;
    line-height: 20px;
    overflow: hidden;
    outline: 0;
    resize: none;
    border-radius: 20px;
    padding: 12px 16px;
    box-sizing: content-box;
    font-size: 16px;
    background: var(--chat-bg-color-input);
    color: var(--chat-color);
    caret-color: var(--chat-color-caret);
    border: var(--chat-border-style-input);

    &::placeholder {
      color: var(--chat-color-placeholder);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .vac-textarea-outline {
    border: 1px solid var(--chat-border-color-input-selected);
    box-shadow: inset 0px 0px 0px 1px var(--chat-border-color-input-selected);
  }

  .vac-icon-textarea,
  .vac-icon-textarea-left {
    display: flex;
    align-items: center;

    svg,
    .vac-wrapper {
      margin: 0 7px;
    }
  }

  .vac-icon-textarea {
    margin-left: 5px;
  }

  .vac-icon-textarea-left {
    display: flex;
    align-items: center;
    margin-right: 5px;

    svg,
    .vac-wrapper {
      margin: 0 7px;
    }

    .vac-icon-microphone {
      fill: var(--chat-icon-color-microphone);
      margin: 0 7px;
    }

    .vac-dot-audio-record {
      height: 15px;
      width: 15px;
      border-radius: 50%;
      background-color: #eb4034;
      animation: vac-scaling 0.8s ease-in-out infinite alternate;

      @keyframes vac-scaling {
        0% {
          transform: scale(1);
          opacity: 0.4;
        }
        100% {
          transform: scale(1.1);
          opacity: 1;
        }
      }
    }

    .vac-dot-audio-record-time {
      font-size: 16px;
      color: var(--chat-color);
      margin-left: 8px;
      width: 45px;
    }

    $audio-icon-size: 28px;

    .vac-icon-audio-stop,
    .vac-icon-audio-confirm {
      min-height: $audio-icon-size;
      min-width: $audio-icon-size;

      svg {
        min-height: $audio-icon-size;
        min-width: $audio-icon-size;
      }
    }

    .vac-icon-audio-stop {
      margin-right: 20px;

      #vac-icon-close-outline {
        fill: var(--chat-icon-color-audio-cancel);
      }
    }

    .vac-icon-audio-confirm {
      margin-right: 3px;
      margin-left: 12px;

      #vac-icon-checkmark {
        fill: var(--chat-icon-color-audio-confirm);
      }
    }
  }

  .vac-send-disabled,
  .vac-send-disabled svg {
    cursor: none !important;
    pointer-events: none !important;
    transform: none !important;
  }

  .vac-messages-hidden {
    opacity: 0;
  }

  @media only screen and (max-width: 768px) {
    .vac-container-scroll {
      margin-top: 50px;
    }

    .vac-box-footer {
      padding: 7px 2px 7px 7px;

      &.vac-box-footer-border {
        border-top: var(--chat-border-style-input);
      }
    }

    .vac-text-started {
      margin-top: 20px;
    }

    .vac-textarea {
      padding: 7px;
      line-height: 18px;

      &::placeholder {
        color: transparent;
      }
    }

    .vac-icon-textarea,
    .vac-icon-textarea-left {
      svg,
      .vac-wrapper {
        margin: 0 5px !important;
      }
    }

    .vac-room-footer {
      width: 100%;
    }

    .vac-icon-scroll {
      bottom: 70px;
    }
  }
}
#vac-audio-player {
  width: 250px;
  overflow: hidden;
  border-top-right-radius: 1em;
  border-bottom-right-radius: 2.5em 1em;

  audio {
    height: 40px;

    &::-webkit-media-controls-panel {
      height: 40px;
    }

    &::-webkit-media-controls-mute-button {
      display: none;
    }

    &::-webkit-media-controls-timeline {
      min-width: 103px;
      max-width: 142px;
    }

    &:focus {
      outline: none;
    }
  }
}
.vac-audio-message {
  margin-top: 3px;
}

.vac-message-highlight {
  box-shadow: 0 1px 2px -1px rgba(0, 0, 0, 0.1),
    0 1px 2px -1px rgba(0, 0, 0, 0.11), 0 1px 5px -1px rgba(0, 0, 0, 0.11);
}

.vac-message-deleted {
  color: #a2a5a8 !important;
  font-size: 13px !important;
  font-style: italic !important;
  // background: #1b1c21 !important;
}

span.unread {
  background: #82e0a8;
  color: #fff;

  display: flex;
  font-weight: 700;
  min-width: 20px;
  justify-content: center;
  align-items: center;
  line-height: 20px;
  font-size: 12px;
  padding: 0 4px;
  border-radius: 25px;
  margin-left: auto;
}

span.unread1 {
  //   background: #82e0a8;
  color: #fff;

  display: flex;
  font-weight: 700;
  min-width: 20px;
  justify-content: center;
  align-items: center;
  line-height: 20px;
  font-size: 12px;
  padding: 0 4px;
  border-radius: 25px;
  margin-left: auto;
}

.typing {
  display: block;
  width: 60px;
  height: 40px;
  border-radius: 18px 18px 18px 0px;
  margin: 1.3rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  display: block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: #8d8d8d;
  margin: 3px;
}
.circle.scaling {
  animation: typing 1000ms ease-in-out infinite;
  animation-delay: 3600ms;
}
.circle.bouncing {
  animation: bounce 1000ms ease-in-out infinite;
  animation-delay: 3600ms;
}

.circle:nth-child(1) {
  animation-delay: 0ms;
}

.circle:nth-child(2) {
  animation-delay: 333ms;
}

.circle:nth-child(3) {
  animation-delay: 666ms;
}

@keyframes typing {
  0% {
    transform: scale(1);
  }
  33% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  33% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}

.people-suggestions {
  display: flex;
}

.people-suggestions span {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  border: 2px solid gainsboro;
  margin-left: -0.6rem;
}
.people-suggestions span:first-child {
  margin: 0;
}
</style>
